import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "toggleable"]
  static values = {
    activeClass: { type: String, default: "block" },
    inactiveClass: { type: String, default: "hidden" }
  }

  connect() {
    this.update()
  }

  update() {
    const triggerValue = this.getTriggerValue()

    this.toggleableTargets.forEach(target => {
      const targetValue = target.dataset.toggleValue

      // Support comma-separated values
      let shouldShow = false
      if (targetValue && triggerValue) {
        const targetValues = targetValue.split(',').map(v => v.trim())
        shouldShow = targetValues.includes(triggerValue)
      }

      this.toggleVisibility(target, shouldShow)
      this.toggleInputs(target, shouldShow)
    })
  }

  getTriggerValue() {
    if (!this.hasTriggerTarget) return null
    const trigger = this.triggerTarget

    switch (trigger.type) {
      case 'checkbox':
        return trigger.checked ? trigger.value : 'false'
      case 'radio':
        const checkedRadio = this.element.querySelector(`input[name="${trigger.name}"]:checked`)
        return checkedRadio ? checkedRadio.value : null
      case 'select-one':
      default:
        return trigger.value
    }
  }

  toggleVisibility(element, show) {
    if (show) {
      element.classList.remove(this.inactiveClassValue)
      element.classList.add(this.activeClassValue)
    } else {
      element.classList.remove(this.activeClassValue)
      element.classList.add(this.inactiveClassValue)
    }
  }

  toggleInputs(element, enable) {
    const inputs = element.querySelectorAll('input, select, textarea')
    inputs.forEach(input => {
      input.disabled = !enable

      // Clear values when disabling to prevent form submission of hidden data
      // if (!enable && input.type !== 'hidden') {
      //   if (input.type === 'checkbox' || input.type === 'radio') {
      //     input.checked = false
      //   } else {
      //     input.value = ''
      //   }
      // }
    })
  }
}
